export default "/images/publico.svg?9a3e63fd156edd66947494f35a9b0e98";